import { faXmarkCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames';
import { Button } from 'components/Button';
import { Modal } from 'components/Modal';
import styles from './ConfirmDeletionModal.scss';

export const ConfirmDeletionModal = ({ isOpen, setIsOpen, elementName, onConfirm, onCancel, className }) => {
  const capitalizeWord = (word) => word.slice(0, 1).toUpperCase() + word.slice(1);

  return (
    <Modal className={cn(styles.modal, className)} isOpen={isOpen} setIsOpen={setIsOpen}>
      <FontAwesomeIcon className={styles.icon} icon={faXmarkCircle} />
      <p className={styles.title}>Видалити {elementName}?</p>
      <p className={styles.text}>Цю дію не можна скасувати. {capitalizeWord(elementName)} буде видалено назавжди.</p>
      <div className={styles.buttons}>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            if (onCancel) onCancel(e);
            setIsOpen(false);
          }}
          className={cn(styles.btn, styles.no)}
        >
          Скасувати
        </Button>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            onConfirm(e);
            setIsOpen(false);
          }}
          className={cn(styles.btn, styles.yes)}
        >
          Видалити
        </Button>
      </div>
    </Modal>
  );
};
